import React from 'react';
import DataRequestGuide from '../../components/DataRequestGuide.jsx';
const steps = [
    {
        id: 'claude-step-1',
        stepLabel: 'Step 1',
        title: 'Where should you begin?',
        image: process.env.PUBLIC_URL + '/Images/steps/Claude_Step1.png',
        imageAlt: 'Claude home screen with menu icon highlighted',
        body: (
        <>
            Open the Claude app or go to{' '}
            <a href="https://claude.ai" target="_blank" rel="noreferrer">
            claude.ai
            </a>
            , then press on the the small icon at the top left of the screen top open the sidebar.
            (If the side menu is already visible, you can skip this step.)
        </>
        ),
    },
    {
        id: 'claude-step-2',
        stepLabel: 'Step 2',
        title: 'Open your profile menu',
        image: process.env.PUBLIC_URL + '/Images/steps/Claude_Step2.png',
        imageAlt: 'Profile icon highlighted in Claude',
        body: (
        <>
            Click on your profile icon, located where your username appears at the
            bottom left of the menu.
        </>
        ),
    },
    {
        id: 'claude-step-3',
        stepLabel: 'Step 3',
        title: 'Go to settings',
        image: process.env.PUBLIC_URL + '/Images/steps/Claude_Step3.png',
        imageAlt: 'Settings option highlighted in Claude menu',
        body: (
        <>
            In the pop-up menu, click on <strong>Settings</strong>.
        </>
        ),
    },
    {
        id: 'claude-step-4',
        stepLabel: 'Step 4',
        title: 'Open privacy settings',
        image: process.env.PUBLIC_URL + '/Images/steps/Claude_Step4.png',
        imageAlt: 'Privacy button highlighted in settings',
        body: (
        <>
            In the settings panel, press the <strong>Privacy</strong> button. Then click on <strong>Export data</strong>.
        </>
        ),
    },
    {
        id: 'claude-step-5',
        stepLabel: 'Step 5',
        title: 'Export your data',
        image: process.env.PUBLIC_URL + '/Images/steps/Claude_Step5.png',
        imageAlt: 'Export data button highlighted',
        body: (
        <>
            In the Privacy menu, click on the <strong>Export</strong> button
            next to “Export data”. An email with a download link will be sent to
            your registered email address within a few minutes to a few hours.
        </>
        ),
    },
];

const ClaudeRequest = () => {
    return (
        <DataRequestGuide
        title="How to Request Your Claude Data"
        intro="Follow these steps to export a copy of your Claude data, which you can then donate through this website."
        steps={steps}
        />
    );
};

export default ClaudeRequest;
